<template>
  <div class="contract" v-if="!isLoading">

    <Verify v-if="verify" :isVerified="supplierProfile.verified" />
    <NeedsToSign v-else-if="needsToSign" />
    <WaitingForContract v-else />

    <b-loading :is-full-page="isLoading" :active.sync="isLoading" :can-cancel="true"></b-loading>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import WaitingForContract from "./WaitingForContract"
import NeedsToSign from "./NeedsToSign"
import Verify from "./Verify"

export default {
  components : {
    WaitingForContract,
    NeedsToSign,
    Verify
  },
  data() {
    return {
      isLoading: false,

    };
  },
  computed: {
    ...mapGetters(["courses","supplierProfile", "supplierToken", "activeStep", "nextStepButtonVisible"]),    
    needsToSign() {
      return !!(this.supplierProfile && this.supplierProfile.extra && this.supplierProfile.extra.contract_signing_url)
    },
    verify() {
      if (!this.supplierProfile) return

      const isSigned = this.supplierProfile.extra && this.supplierProfile.extra.docusign_envelope_id
      const isVerified = this.supplierProfile.verified

      return isSigned || isVerified
    }
  },
  methods: {},

  created() {
    if(!this.supplierProfile.verified) {
      if (this.supplierProfile && this.supplierProfile.extra && !this.supplierProfile.extra.exam) {
        this.$router.push({name : 'training'})
      } else {
        this.isLoading = true
        this.$store.dispatch("getAllCourses", this.supplierToken).then(() => {
          this.isLoading = false
            if(this.nextStepButtonVisible === false){
              this.$router.push({name : 'training'})
              this.$buefy.notification.open({
                message: 'Vui lòng hoàn thành bộ câu hỏi bắt buộc !',
                type: "is-warning",
                duration: 3000,
                position: "is-bottom"
              });
            }
          })
      }
    }
  },
};
</script>
<style lang="scss">
.contract {
  .text {
    max-width: 500px;
    position: absolute;
    top: 10%;
    .reload-note{
      color: #7a8189;
      font-size: 16px;
      img{
        width: 20px;
        height: 15px;
      }
      a{
        color: #ff8200;
        line-height: 20px;
        font-weight: 500;
        text-align: center
      }
    }
    .reload-note.is-flex{
      align-items: center;
      p{
        margin: 0
      }
      progress{
        margin-left: 10px;
        border-radius: 20px;
        height: 10px;
      }
      progress::-webkit-progress-value{
        background: #ff8200;
        border-radius: 20px;
        height: 10px;
      }
      progress::-webkit-progress-bar {
        background-color: #ededed;
        border-radius: 20px;
        height: 10px;
      }
      progress::-moz-progress-bar {
        background-color: #ededed;
        height: 10px;
        border-radius: 20px;
      }
      progress[value] {
        -webkit-appearance: none;
        appearance: none;
        border-radius: 20px;
        height: 10px;
      }
    }
    p.scan-qr{
      margin: 20px 0;
    }
    h1 {
      margin: 0 0 20px 0;
      color: #1a1a1a;
      font-size: 30px;
    }
    span {
      color: #7a8189;
      font-size: 16px;
    }
    .button {
      margin-top: 20px;
      margin-bottom: 20px;
      width: 160px;
      height: 44px;
      background-color: #ff8200;
      color: #fff;
      border: 0;

      &:hover {
        border: 0;
        outline: none;
      }
      span {
        color: #fff;
        font-size: 16px;
      }
    }
  }
  .guide{
    margin-top: 20px;
      a.intro{
      color: #ff8200
    }
  }
  
}
</style>
